import moment from "moment";

export function calculateWeekNumbers(activeTab, year) {
	let startDate, endDate;

	// Check activeTab to determine start and end dates
	// eslint-disable-next-line eqeqeq
	if (activeTab == "1") {
		// January to June
		startDate = moment().year(year).startOf("year");
		endDate = moment().year(year).startOf("year").month(5).endOf("month");
	} else {
		// July to December
		startDate = moment().year(year).startOf("year").month(6);
		endDate = moment().year(year).startOf("year").month(11).endOf("month");
	}

	// Initialize an array to store week numbers
	let weekNumbers = [];

	// Iterate through each week from start to end date
	let currentDate = startDate.clone();
	while (currentDate.isSameOrBefore(endDate)) {
		// Get the ISO week number for the current date
		const weekNumber = currentDate.isoWeek();

		// Store the week number in the array
		// eslint-disable-next-line eqeqeq
		if (activeTab == "2") {
			if (weekNumber !== 1) {
				weekNumbers.push(weekNumber);
			}
		} else {
			weekNumbers.push(weekNumber);
		}

		// Move to the next week
		currentDate.add(1, "week");
	}

	return weekNumbers; // Return the array of week numbers
}
